module.exports = __webpack_public_path__ + "img/boxed-17.2c84c00f.jpg";